const firstNonEmpty = (...values) => {
  for (const value of values) {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return value;
    }
  }
  return null;
};

export const getProcessedByRoleDisplayName = role => {
  if (!role) return null;
  const roleMap = {
    super_admin: 'Super Admin',
    admin: 'Admin',
    operations_officer: 'Operations Officer',
    organisation_manager: 'Operations Officer',
    user_onboarding: 'Talent Manager',
    talent_manager: 'Talent Manager',
    finance_officer: 'Finance Officer',
    compliance_auditor: 'Compliance Auditor',
    support_associate: 'Support Associate',
  };
  return roleMap[role] || role;
};

export const formatActorNameWithRole = (name, role) => {
  if (!name) return '---';
  if (role) {
    const roleDisplay = getProcessedByRoleDisplayName(role);
    return `${name} - ${roleDisplay}`;
  }
  return name;
};

export const getSubjectRequestActors = request => {
  if (!request) return { approved: null, rejected: null };

  let approved = null;
  if (request.status === 'approved') {
    const details = request.approved_by_details;
    approved = {
      name: firstNonEmpty(
        details?.name,
        request.approved_by_name,
        request.approved_by,
        request.processed_by
      ),
      role: firstNonEmpty(
        details?.admin_role,
        details?.user_type,
        request.approved_by_user_role,
        request.processed_by_user_role
      ),
      at: firstNonEmpty(request.approved_at, request.updated_at),
    };
  }

  let rejected = null;
  if (request.status === 'rejected') {
    const details = request.rejected_by_details;
    rejected = {
      name: firstNonEmpty(
        details?.name,
        request.rejected_by_name,
        request.rejected_by,
        request.processed_by
      ),
      role: firstNonEmpty(
        details?.admin_role,
        details?.user_type,
        request.rejected_by_user_role,
        request.processed_by_user_role
      ),
      reason: request.reason,
      at: firstNonEmpty(request.rejected_at, request.updated_at),
    };
  }

  return { approved, rejected };
};

export const getUserAccountAudit = user => {
  if (!user) return { disabled: null, enabled: null };

  if (user.is_active === false) {
    const details = user.disabled_by_details;
    return {
      disabled: {
        name: firstNonEmpty(details?.name, user.disabled_by_name, user.disabled_by),
        role: firstNonEmpty(details?.admin_role, details?.user_type, user.disabled_by_user_role),
        at: firstNonEmpty(user.disabled_at, user.updated_at),
        reason: user.reason_for_disable,
      },
      enabled: null,
    };
  }

  const hasEnabledAudit = !!(
    user.enabled_by ||
    user.enabled_by_details ||
    user.enabled_by_name ||
    user.enabled_at
  );

  if (!hasEnabledAudit) {
    return { disabled: null, enabled: null };
  }

  const details = user.enabled_by_details;
  return {
    disabled: null,
    enabled: {
      name: firstNonEmpty(details?.name, user.enabled_by_name, user.enabled_by),
      role: firstNonEmpty(details?.admin_role, details?.user_type, user.enabled_by_user_role),
      at: firstNonEmpty(user.enabled_at, user.updated_at),
    },
  };
};
